import { CircuitStepDaytime } from '@/types/circuits/CircuitStepDaytime';
import { LabelValue } from '@/types/global';
import { Translator } from '@/types/translator.type';

export const CIRCUIT_DAY_PERIODS = (
  t: Translator,
): LabelValue<CircuitStepDaytime>[] => [
  {
    label: t('circuits.daytimePeriods.breakfast'),
    value: CircuitStepDaytime.Breakfast,
  },
  {
    label: t('circuits.daytimePeriods.morning'),
    value: CircuitStepDaytime.Morning,
  },
  {
    label: t('circuits.daytimePeriods.lunch'),
    value: CircuitStepDaytime.Lunch,
  },
  {
    label: t('circuits.daytimePeriods.afternoon'),
    value: CircuitStepDaytime.Afternoon,
  },
  {
    label: t('circuits.daytimePeriods.dinner'),
    value: CircuitStepDaytime.Dinner,
  },
  {
    label: t('circuits.daytimePeriods.evening'),
    value: CircuitStepDaytime.Evening,
  },
  {
    label: t('circuits.daytimePeriods.night'),
    value: CircuitStepDaytime.Night,
  },
];
